var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserChange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 4C10.5717 4 9.6815 4.36875 9.02513 5.02513C8.36875 5.6815 8 6.57174 8 7.5C8 8.42826 8.36875 9.3185 9.02513 9.97487C9.6815 10.6313 10.5717 11 11.5 11C12.4283 11 13.3185 10.6313 13.9749 9.97487C14.6313 9.3185 15 8.42826 15 7.5C15 6.57174 14.6313 5.6815 13.9749 5.02513C13.3185 4.36875 12.4283 4 11.5 4ZM6 7.5C6 6.04131 6.57946 4.64236 7.61091 3.61091C8.64236 2.57946 10.0413 2 11.5 2C12.9587 2 14.3576 2.57946 15.3891 3.61091C16.4205 4.64236 17 6.04131 17 7.5C17 8.95869 16.4205 10.3576 15.3891 11.3891C14.3576 12.4205 12.9587 13 11.5 13C10.0413 13 8.64236 12.4205 7.61091 11.3891C6.57946 10.3576 6 8.95869 6 7.5ZM19.05 13.088L23.908 18.002L19.05 22.916L17.628 21.51L20.108 19.002H12.998V17.002H20.108L17.628 14.494L19.05 13.088ZM8 16C6.93913 16 5.92172 16.4214 5.17157 17.1716C4.42143 17.9217 4 18.9391 4 20V22H2V20C2 18.4087 2.63214 16.8826 3.75736 15.7574C4.88258 14.6321 6.4087 14 8 14H12V16H8Z",
    fill: "#F5F5F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserChange);
export default __webpack_public_path__ + "static/media/user-change.46923249cc896eac5562cbf814b3ccab.svg";
export { ForwardRef as ReactComponent };